import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEyeOff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			id: "eye-off",
			clipPath: "url(#clip0_10616_7970)",
			children: [/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M17.94 17.94C16.2306 19.243 14.1491 19.9649 12 20C5 20 1 12 1 12C2.24389 9.68192 3.96914 7.65663 6.06 6.06003M9.9 4.24002C10.5883 4.0789 11.2931 3.99836 12 4.00003C19 4.00003 23 12 23 12C22.393 13.1356 21.6691 14.2048 20.84 15.19M14.12 14.12C13.8454 14.4148 13.5141 14.6512 13.1462 14.8151C12.7782 14.9791 12.3809 15.0673 11.9781 15.0744C11.5753 15.0815 11.1752 15.0074 10.8016 14.8565C10.4281 14.7056 10.0887 14.4811 9.80385 14.1962C9.51897 13.9113 9.29439 13.572 9.14351 13.1984C8.99262 12.8249 8.91853 12.4247 8.92563 12.0219C8.93274 11.6191 9.02091 11.2219 9.18488 10.8539C9.34884 10.4859 9.58525 10.1547 9.88 9.88003",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}), /* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M1 1L23 23",
				stroke: "white",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_10616_7970",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgEyeOff);
export { ForwardRef as ReactComponent };
